import { BatchExecutionResult } from './MyAccessRequests.types';

export interface SequentialActionHandlers<TItem> {
  validate: (item: TItem) => string | null;
  execute: (item: TItem) => Promise<{ ok: boolean; message: string }>;
  onSuccess: (item: TItem, message: string) => void;
  onFailure: (item: TItem, message: string) => void;
}

export async function executeSequential<TItem>(
  items: TItem[],
  handlers: SequentialActionHandlers<TItem>
): Promise<BatchExecutionResult> {
  let successCount = 0;
  let failedCount = 0;

  for (const item of items) {
    const validationError = handlers.validate(item);
    if (validationError) {
      failedCount += 1;
      handlers.onFailure(item, validationError);
      continue;
    }

    try {
      const result = await handlers.execute(item);
      if (result.ok) {
        successCount += 1;
        handlers.onSuccess(item, result.message);
      } else {
        failedCount += 1;
        handlers.onFailure(item, result.message);
      }
    } catch (error) {
      failedCount += 1;
      handlers.onFailure(item, error?.message || 'Unexpected error');
    }
  }

  return {
    total: items.length,
    successCount,
    failedCount
  };
}
